module.exports = __webpack_public_path__ + "static/media/103.72208b65.jpg";